module.exports = __webpack_public_path__ + "img/image_3.1169f237.jpg";